module.exports = __webpack_public_path__ + "static/media/yellowbus_logo_icon.caf2fa63.svg";